module.exports = function () {
    return function (deliverySaverPlan = {}) {
        if (deliverySaverPlan.IsAnyDay) {
            return 'Delivery Plus Anyday';
        } else if (deliverySaverPlan.IsMidweek) {
            return 'Delivery Plus Midweek';
        }
        return 'Delivery Plus';
    };
};



// WEBPACK FOOTER //
// ./src/deliverysaver/delivery-saver-type-name.filter.js